"use client"

import React from "react"

import { Flag } from "components/dataDisplay"
import { Href } from "components/navigation"

import { GameSkeleton } from "compositions/events/Game/Game"
import SxGame from "../Game/SxGame"

export const SxLeagueSkeleton: React.FC<{ isPage?: boolean }> = ({
  isPage = false,
}) => {
  return (
    <div className="mt-1 first-of-type:mt-0">
      {isPage ? (
        <div className="py-3 px-4">
          <div className="bone h-[1.375rem] w-44 rounded-full" />
        </div>
      ) : (
        <div className="rounded-t-md flex items-center justify-between py-2 px-4 bg-accent-grey-850 mb-[2px]">
          <div className="flex items-center">
            <div className="bone size-4 mr-2 rounded-full" />
            <div className="bone h-[0.875rem] w-[8rem] rounded-md" />
            <div className="size-1 rounded-full mx-2 bg-accent-grey-700" />
            <div className="bone h-[0.875rem] w-[4rem] rounded-md" />
          </div>
        </div>
      )}
      <div className="space-y-[2px]">
        {new Array(3).fill(0).map((_, index) => (
          <GameSkeleton
            key={index}
            className={isPage ? "first-of-type:rounded-t-md" : ""}
          />
        ))}
      </div>
    </div>
  )
}

type SxLeagueProps = {
  sportSlug: string
  league: any
  isPage?: boolean
  showFilter?: boolean
  isFirstLeague?: boolean
}

const SxLeague: React.FC<SxLeagueProps> = ({
  sportSlug,
  league,
  isPage = false,
  showFilter = false,
  isFirstLeague = false,
}) => {
  const { slug, name, countryName, countrySlug, games } = league
  const leagueUrl = `/${sportSlug}/${countrySlug}/${slug}`

  return (
    <div className="mt-1 first-of-type:mt-0">
      <div className="rounded-t-md flex items-center justify-between py-2 px-4 bg-accent-grey-850 mb-[2px]">
        <Href to={leagueUrl} className="flex items-center hover:underline">
          <Flag className="mr-2" country={countrySlug} />
          <div className="text-caption-12 text-[#ADADAD]">{countryName} </div>
          <div className="size-1 rounded-full mx-2 bg-accent-grey-700" />
          <div className="text-caption-12 text-accent-grey-10">{name}</div>
        </Href>
      </div>
      <div className="space-y-[2px]">
        {games.map((game, index) => (
          <SxGame
            key={game.markets[0].marketHash}
            leagueUrl={leagueUrl}
            game={game}
            withTopRadius={isPage}
            showFilter={showFilter}
            isFirstGame={isFirstLeague && index === 0}
          />
        ))}
      </div>
    </div>
  )
}

export default SxLeague
